import {mapiqApi} from '@lib/infrastructure';
import {createAsyncThunk} from '@reduxjs/toolkit';
import {AppThunkApiConfig} from '../../createStore';
import {FloorMap, Facility} from '../entities';
import {MapType} from './types';

export const loadMap = createAsyncThunk<
  FloorMap,
  {buildingId: string; floorId: string; type: MapType},
  AppThunkApiConfig
>(
  'floors/loadMap',
  async ({buildingId, floorId, type}, {extra}) => {
    const client = extra.apiClient;
    const api = mapiqApi(client);

    if (type === '3d') {
      return {
        id: floorId,
        type,
        map: await api.get3dMapByFloorId(buildingId, floorId),
      };
    }

    if (type === '2d') {
      return {
        id: floorId,
        type,
        map: await api.getMapByFloorId(buildingId, floorId),
      };
    }

    throw new Error(`Invalid map type (${type})`);
  },
  {
    condition: ({floorId, type}, {getState}) => {
      const state = getState();
      const currentData = state.data.floors.mapData[type][floorId];

      if (currentData?.status === 'Loading') {
        return false;
      }
    },
  },
);

export const loadFacilities = createAsyncThunk<Facility[], {buildingId: string; floorId: string}, AppThunkApiConfig>(
  'floors/loadFacilities',
  async ({buildingId, floorId}, {extra}) => {
    const client = extra.apiClient;
    const api = mapiqApi(client);
    const response = await api.getFacilitiesByFloorId(buildingId, floorId);

    return response;
  },
);
